import useVoiceDumpStore from '../../stores/useVoiceDumpStore';

/**
 * ModeSelector — Visual pill-based mode selector that replaces the old dropdown.
 * Each mode is a horizontal scrollable pill. Active pill has brand gradient.
 * Page-aware auto-selection is handled by the store (openWizard(mode)).
 */
export default function TemplateSelector() {
  const selectedTemplate = useVoiceDumpStore(s => s.selectedTemplate);
  const setTemplate = useVoiceDumpStore(s => s.setTemplate);
  const getAllTemplates = useVoiceDumpStore(s => s.getAllTemplates);

  const templates = getAllTemplates();

  return (
    <div className="vd-mode-selector" role="tablist" aria-label="Voice dump mode">
      {templates.map(mode => (
        <button
          key={mode.id}
          className={`vd-mode-pill ${mode.id === selectedTemplate ? 'vd-mode-pill--active' : ''}`}
          onClick={() => setTemplate(mode.id)}
          type="button"
          role="tab"
          aria-selected={mode.id === selectedTemplate}
          title={mode.description}
        >
          <span className="vd-mode-pill__emoji">{mode.emoji}</span>
          <span className="vd-mode-pill__name">{mode.name}</span>
        </button>
      ))}
    </div>
  );
}
